module.exports = __webpack_public_path__ + "media/images/unlike-24ba33a547100a1429920dd8dfc33a01.png";